<template>
<div class="max_width_product_type">
      <div class="layout-breadcrumb">
        <Breadcrumb>
            <BreadcrumbItem >
                <Icon type="social-buffer-outline" style="color:#fff"></Icon> 
                <span style="color:#fff">品种牌号管理</span>
            </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="layout-content">
        <div class="layout-content-main">
          <div class="layout_content_left_tree treeLeft">
            <Button class="layout_content_left_tree_btn" icon='ios-plus-empty' @click="append({'id':'0'})" type='primary'></Button>  
            <Tree :data="dataNews" :render="renderContent" ref="tree"></Tree>
          </div>
          <div class="treeRight">
            <div class="houseTitle">品种信息</div>
            <Form ref="formVarietyInformation" :model="formVarietyInformation" :rules="ruleVarietyInfor" :label-width="100" label-position="left">
                <div :class="{formLine_order:!showProductTypeId,formLine:showProductTypeId}" >
                   <FormItem label="品种代码" v-show="showProductTypeId" prop="productTypeId">
                      <Input v-model="formVarietyInformation.productTypeId" :disabled=disabledInput placeholder=""></Input>
                  </FormItem>
                   <FormItem class="form_line_item" label="品种名称" prop="productTypeName">
                      <Input v-model="formVarietyInformation.productTypeName" :disabled=disabledInput placeholder=""></Input>
                  </FormItem>
                </div>
                <div class="formLine" >
                   <FormItem label="父级品种代码" prop="prodTypeFather">
                      <Input v-model="formVarietyInformation.prodTypeFather" disabled placeholder=""></Input>
                  </FormItem>
                   <FormItem class="form_line_item" label="级数" prop="prodTypeLevel">
                      <Input v-model="formVarietyInformation.prodTypeLevel" :disabled=disabledInput placeholder=""></Input>
                  </FormItem>
                  <!-- <FormItem label="仓库类型" prop="warehouseType">
                      <Select v-model="formVarietyInformation.warehouseType" placeholder="Select your city">
                          <Option value="beijing">自有</Option>
                          <Option value="shanghai">London</Option>
                          <Option value="shenzhen">Sydney</Option>
                      </Select>
                  </FormItem> -->
                </div>
                <div class="formLine_order" >
                   <!-- <FormItem label="是否子节点" prop="varietyChildId">
                      <Input v-model="formVarietyInformation.varietyChildId" disabled placeholder=""></Input>
                  </FormItem> -->
                   <FormItem class="form_line_item" label="显示顺序" prop="orderNum">
                      <Input v-model="formVarietyInformation.orderNum" :disabled=disabledInput placeholder=""></Input>
                  </FormItem>
                </div>
                <div class="formLine" >
                  <FormItem label="备注" prop="remark">
                    <!-- <Input class="form_line_textarea" type="textarea" :rows="3" v-model="formVarietyInformation.remark" :disabled=disabledInput placeholder=""></Input> -->
                    <textarea class="form_line_textarea" :class="{form_line_textarea_edit:disabledInput}" v-model="formVarietyInformation.remark" :disabled=disabledInput placeholder="">
                    </textarea>  
                  </FormItem>
                </div>
                <div class="formLine"  v-show="showProductTypeId">
                   <FormItem label="创建人" prop="createBy">
                      <Input v-model="formVarietyInformation.createBy" disabled placeholder=""></Input>
                  </FormItem>
                   <FormItem class="form_line_item" label="创建时间" prop="createDate">
                      <Input v-model="formVarietyInformation.createDate" disabled placeholder=""></Input>
                  </FormItem>
                </div>
               
                <FormItem>
                    <Button type="primary" class="mRight" v-show="!disabledInput"  @click="warehouseSubmit(formVarietyInformation)">保存</Button>
                    <Button type="primary" class="mRight" v-show="disabledInput" @click="changeAdmin">编辑</Button>
                    <Button type="primary" v-show="disabledInput" class="mRight"  @click="warehousedelet">删除</Button>
                    <Button type="ghost" class="mRight"  v-show="!disabledInput"  @click="warehouseReset()">取消</Button>
                </FormItem>
            </Form>

            <div class="houseTitle">牌号信息</div>
            <div class="method-wrapper">
              <div style="display:inline-block;" v-if="isbutShow.selectBut">
               <template>
                  <Input v-model="key" placeholder="牌号信息" style="width: 300px"></Input>
              </template>
                
                <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
                
              </div>
            
              <Button type="primary" class="mRight" v-if="isbutShow.addBut" @click="addAdmin">新增</Button><Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
              <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>   
            </div>

            <div class="clearfix"></div>
            <div class="table-wrapper">
              <Table style="min-width: 600px;" border :columns="columns" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
              <div style="margin: 10px;overflow: hidden">
                  <div style="float: right;">
                       <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                  </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{activeName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" label-position="left" :model="formValidate" :rules="ruleValidate" :label-width="150">
              <!-- <FormItem label="币种代码" prop="currencyId">
                  <Input v-model="formValidate.currencyId" placeholder="请输入币种代码"></Input>
              </FormItem> -->
              <!-- <FormItem label="品种代码" prop="productTypeId">
                  <Input v-model="formValidate.productTypeId" placeholder="请输入品种代码"></Input>
              </FormItem> -->
              <FormItem label="品种名称" prop="productTypeName">
                  <Input v-model="formValidate.productTypeName" placeholder="请输入品种名称" ></Input>
              </FormItem>
               <!-- <FormItem label="所属部门" prop="dePtNode"> -->
                  <!-- <Button type="default" long  @click="getDepartment">所属部门</Button>    -->
                  <!-- {{treeNode}} -->
                  <!-- <Button type="default" long style="text-align:left;" @click=" modalDept = true " >{{treeNode}}</Button> -->
              <!-- </FormItem> -->
              <FormItem label="牌号" prop="shopsign">
                  <Input v-model="formValidate.shopsign" placeholder="请输入牌号"></Input>
              </FormItem>
               <FormItem label="技术标准" prop="techStandard">
                  <Input v-model="formValidate.techStandard" placeholder="请输入技术标准"></Input>
              </FormItem>
              <FormItem label="是否有效" prop="isValid">
                  <Input v-model="formValidate.isValid" placeholder="请输入是否有效"></Input>
              </FormItem>
               <FormItem label="备注" prop="remark">
                  <Input v-model="formValidate.remark" placeholder="请输入备注"></Input>
              </FormItem>
              <!-- <FormItem label="角色" prop="role">

              </FormItem> -->
              <!-- <FormItem label="状态" prop="status" style="text-align:left;">
                  <RadioGroup v-model="formValidate.status">
                    <Radio label="0" :class="[formValidate.status == '0' ? 'ivu-radio-checked' : '']">禁用</Radio>
                    <Radio label="1" :class="[formValidate.status == '1' ? 'ivu-radio-checked' : '']">正常</Radio>
                </RadioGroup>
              </FormItem> -->
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit" long :loading="modal_loading" >确定</Button>
        </div>
    </Modal>
</div>
     
</template>
<style scoped lang="scss">
  
  .treeLeft{
    width:190px;
    height: 100%;
    position: absolute;
    border-right: solid 2px #eee;
  }

  .treeRight{
    margin-left:200px;
    overflow:hidden;
  }
  .layout-content-main{
    overflow: hidden;
  }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .table-wrapper {
    width:100%;
  }

  .houseTitle{
    width:100%;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: #495060;
    padding: 0 15px;
    margin-bottom: 20px;
    font-size: 16px;
  }
  .method-wrapper {
    float: left;
    margin: 0 0 15px 15px;
  }

  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  .formLine{
    width:700px;
    padding-left: 30px;
    display: flex;
    .form_line_textarea{ 
      text-indent:5px;
      resize:none;
      width:100%;
      border:1px solid #eee;
      border-radius: 4px;
      background-color: #fff;
      color: #495060;
    }
    .form_line_textarea_edit{
      background-color: #f3f3f3;
      color:#ccc;
    }
    .form_line_item{
      margin-left: 50px;
    }
  }
  .formLine_order{
    width:341px;
    padding-left: 30px;
    /*display: flex;
    .form_line_item{
      margin-left: 50px;
    }*/
  }
  .formLine .ivu-form-item{
    flex:1;
    margin-bottom: 20px;
  }
</style>
<script>
  import api from '../../api/apinew'
  //import leftBar from '../../components/leftBar'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        showProductTypeId:true,
        modal_loading: false,
        formValidate: {
            productTypeId:'',
            productTypeName:'',
            shopsign: '',
            techStandard: '',
            isValid: '',
            remark: '',
        },
        ruleValidate: {
            // currencyId: [
            //     { required: true, message: '币种代码不能为空', trigger: 'blur' }
            // ],
            // productTypeId:[
            //     // { required: true,validator: validatePass, trigger: 'blur' },
            //     { required: true, message: '品种代码不能为空', trigger: 'blur' }
            // ],
            productTypeName:[
                { required: true, message: '品种名称不能为空', trigger: 'blur' }
            ],
            shopsign:[
               { required: true, message: '牌号不能为空',  trigger: 'blur' }
            ],
            techStandard: [
                { required: true, message: '技术标准不能为空', trigger: 'blur' }
            ],
            isValid: [
                { required: true, message: '是否有效不能为空', trigger: 'blur' }
            ],
            remark: [
                { required: true, message: '备注不能为空', trigger: 'blur' }
            ],
           
        },
        addModel: false,
        selectgetNode:{},
        disabledInput:true,
        selectionRows:[],
        key:'',
        activeName:'',
        productActiveName:'',
        isbutShow:{
          addBut: false,
          delBut: false,
          updateBut: false,
          selectBut: false,
        },
        formVarietyInformation: {
          productTypeId: '',
          productTypeName: '',
          prodTypeFather: '',
          prodTypeLevel: '',
          // varietyChildId:'',
          orderNum:'',
          createBy:'',
          createDate:'',
          remark:'',
        },
        ruleVarietyInfor: {
            productTypeId: [
              { required: true, message: '品种代码不能为空', trigger: 'blur' }
            ],
            productTypeName: [
              { required: true, message: '品种名称不能为空', trigger: 'blur' }
            ],
            // orderNum: [
            //   { required: true,validator:validateNum, trigger: 'blur' }
            // ]
            // prodTypeLevel: [
            //     { required: true,validator:validateNum,trigger: 'blur' },
            // ],
        },
        dataNews: [],
        buttonProps: {
            type: 'ghost',
            size: 'small',
        },
        columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {   
              title: '品种代码',
              key:'productTypeId',
              align: 'center'
          },
          {
              title: '品种名称',
              key: 'productTypeName',
              align: 'center'
          },
          {
              title: '牌号',
              key: 'shopsign',
              align: 'center',
          },
          {
              title: '技术标准',
              key: 'techStandard',
              align: 'center'
          },
          {
              title: '是否有效',
              key: 'isValid',
              align: 'center',
          },
          {
              title: '备注',
              key: 'remark',
              align: 'center',
          },
        ],
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        selectedId:[],
      }
    },
    methods: {
      handleSubmit() {
        let that = this;
        if(that.activeName == "修改"){
          let selection = that.selectionRows[0];
          let formVarietyInforma = that.formValidate;
          formVarietyInforma.id = selection.id;
          formVarietyInforma.segNo = selection.segNo;
          api.Sign.update(formVarietyInforma, resp => {
            // console.log(resp)
            if(resp.code == 0){
              that.$Message.success('修改成功!');
              that.addModel = false;
              that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
            }
            
          }, error => {

          })
        }
        if(that.activeName == '新增'){
          that.formValidate.productTypeId = that.formVarietyInformation.productTypeId;
          api.Sign.addCurrency(that.formValidate, resp => {
            // console.log(resp)
            if(resp.code == 0){
              that.$Message.success('新增成功!');
              that.addModel = false;
              that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
            }
            
          }, error => {

          })
        }
      },
      warehousedelet(){
        let that = this;
        // let node ={
        //   id:that.selectgetNode.id
        // } 
        let nodeId = that.selectgetNode.id;
        let htmlContent = '确定删除该品种吗？';
        if(that.selectgetNode.children.length != 0){
          htmlContent= '该品种下已维护子品种信息，若删除该品种，所属子品种都会删除，请确认！';
        }
        that.$Modal.confirm({
            title: '警告',
            content: htmlContent,
            onOk: () => {
              api.Product.delete(nodeId, resp => {
                // console.log(resp)
                if(resp.code == 0)
                that.$Message.success('Success!');
                // location.reload()
                that.getTree();
                that.disabledInput = true;
                // console.log(node)
              }, error => {
                
              })
            }
        });
      },
      changeAdmin(){
        this.productActiveName = '',
        // this.selectgetNode =  this.formVarietyInformation;
        this.disabledInput = false;
      },
      getNodes(node){
        // console.log(node);
        let that = this;
        that.selectgetNode = node;
        // let ifEnd;
        // if(node.ifEnd == '0'){
        //   ifEnd = '有'
        // }
        // if(node.ifEnd == '1'){
        //   ifEnd = '没有'
        // }
        api.Sign.getLists({
            'page':that.pagerData.page.pageCurrent,
            'limit':that.pagerData.page.pagesize,
            'productTypeId':node.id,
        }, resp => {
          // console.log(resp);
          that.formVarietyInformation= {
          productTypeId: node.productTypeId,
          productTypeName: node.productTypeName,
          prodTypeFather: node.prodTypeFather,
          prodTypeLevel: node.prodTypeLevel,
          // varietyChildId:ifEnd,
          orderNum:node.orderNum,
          createBy:node.createBy,
          createDate:node.createDate,
          remark:node.remark,
        },
          that.disabledInput = true;
          // 获取分页展示list
          that.pagerData.data = resp.page.list;
          // console.log(this.pagerData.data)
          // 获取分页总条数
           that.pagerData.page.totalCount = resp.page.totalCount;
        }, error => {
          
        })    
      },
      getTree(){
        let that = this;
        api.Product.getLists({
          }, resp => {
            // console.log(resp)
            //准备数据
            if(resp.msg == 'success' && resp.list.length != 0)
            that.dataNews = [];//初始化
            let allRes = resp.list;
            function treeObj(originObj){  
              // console.log(originObj)
                //对象深拷贝  
                let obj ={};
                for (let key in originObj){  
                    var val = originObj[key];  
                    obj[key] = typeof val === 'object' ? JSON.parse(JSON.stringify(val)):val;  
               }  

               //对象新增children键值，用于存放子树  
               obj['children'] = [];  
               return obj;  
            }  
      
            //data：带转换成树形结构的对象数组  
            //attributes：对象属性  
            function toTreeData (data, attributes) {  
              let resData = data;  
              let tree = [];  
              // console.log(resData)
             //找寻根节点  
              for (let i = 0; i < resData.length; i++) {  
                resData[i].title = resData[i].productTypeName;
                if (resData[i][attributes.prodTypeFather] === '0'|| resData[i][attributes.prodTypeFather] === null) {  
                  tree.push( treeObj(resData[i]) );  
                  resData.splice(i, 1);  
                  i--;  
                }  
              }  
              
              run(tree);  
              
              //找寻子树  
              function run(chiArr) {  
                if (resData.length !== 0) {  
                  for (let i = 0; i < chiArr.length; i++) {  
                    for (let j = 0; j < resData.length; j++) {  
                      if (chiArr[i][attributes.id] === resData[j][attributes.prodTypeFather]){  
                        let obj = treeObj(resData[j]);  
                        chiArr[i].children.push(obj);  
                        resData.splice(j, 1);  
                        j--;  
                      }  
                    }  
                    run(chiArr[i].children);  
                  }  
                }  
              }  
              
              return tree;  
              
            }  
      
            let data = allRes;
            // console.log(data)  
            // 属性配置信息  
            let attributes = {  
                  id: 'id',  
                  prodTypeFather: 'prodTypeFather',  
              };  
            let treeData = toTreeData(data, attributes);  
            that.dataNews= treeData;
            that.getNodes(that.dataNews[0])
          }, error => {
          })
      },
      warehouseSubmit (name) {
        let that = this;
        let node = that.selectgetNode;
        if(that.productActiveName = '新增'){
          let formVarietyInforma = that.formVarietyInformation;
          console.log(formVarietyInforma)
          api.Product.addCurrency(formVarietyInforma, resp => {
            console.log(resp)

            if(resp.code == 0)
            that.$Message.success('Success!');
            that.getTree();
            that.disabledInput = true;
            that.productActiveName = ''
             //  that.getNodes(formVarietyInforma)
              // console.log(node)
            // location.reload()
          }, error => {
            
          })
          return;
        }
        let formVarietyInforma = that.formVarietyInformation;
        formVarietyInforma.id = node.id;
        formVarietyInforma.segNo = node.segNo;
        // let formVarietyInformation= {
        //   productTypeId: node.productTypeId,
        //   productTypeName: node.productTypeName,
        //   prodTypeFather: node.prodTypeFather,
        //   prodTypeLevel: node.prodTypeLevel,
        //   // varietyChildId:ifEnd,
        //   orderNum:node.orderNum,
        //   createBy:node.createBy,
        //   createDate:node.createDate,
        //   remark:node.remark,
        // },
          api.Product.update(formVarietyInforma, resp => {
             // console.log(resp)
             if(resp.code == 0)
              that.$Message.success('Success!');
              that.disabledInput = true;
              that.getNodes(formVarietyInforma)
              // console.log(node)
          }, error => {
            
          })
          // this.$refs[name].validate((valid) => {
          //     if (valid) { 
          //         this.$Message.success('Success!');
          //     } else {
          //         this.$Message.error('Fail!');
          //     }
          // })
      },
      warehouseReset () {
        let node = this.selectgetNode;
        this.formVarietyInformation = {
        productTypeId: node.productTypeId,
        productTypeName: node.productTypeName,
        prodTypeFather: node.prodTypeFather,
        prodTypeLevel: node.prodTypeLevel,
        // varietyChildId:ifEnd,
        orderNum:node.orderNum,
        createBy:node.createBy,
        createDate:node.createDate,
        remark:node.remark,
        }
        this.disabledInput = true;
          // this.$refs[name].resetFields();
      },
      renderContent (h, { root, node, data }) {
          // console.log(data)
          return h('span', {
              style: {
                  display: 'inline-block',
                  minWidth: '100%',
                  cursor:'pointer',
                  height:'34px'
              }
          }, [
              h('Button',{
                style: {
                    display: 'inline-block',
                    width: '100px',
                    cursor:'pointer',
                    height:'34px',
                    marginRight:'32px',
                },
                attrs: {
                    title: data.title
                },
                on: {
                    click: (e) => { 
                      this.getNodes(data)
                      //console.log(this.$refs.tree.getSelectedNodes);
                      //e.target.style.backgroundColor='skyblue'
                    }
                }
              }, [
                  h('Icon', {
                      props: {
                          type: 'ios-paper-outline',
                      },
                      style: {
                          marginRight: '8px',
                          verticalAlign: 'middle'
                      }
                  }),
                  h('span',{
                    style: {
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        overflow:'hidden',
                        //marginRight: '8px',
                        maxWidth: '100%',
                        textOverflow :'ellipsis',
                    }
                  }, data.title)
              ]),
              h('span', {
                  style: {
                      display: 'inline-block',
                      // float: 'right',
                      marginRight: '32px',
                      height:'34px'
                  }
              }, [
                  h('Button', {
                      props: Object.assign({}, this.buttonProps, {
                          icon: 'ios-plus-empty'
                      }),
                      style: {
                          marginRight: '8px'
                      },
                      on: {
                          click: () => { this.append(data) }
                      }
                  }),
                  // h('Button', {
                  //     props: Object.assign({}, this.buttonProps, {
                  //         icon: 'ios-minus-empty'
                  //     }),
                  //     on: {
                  //         click: () => { this.remove(root, node, data) }
                  //     }
                  // })
              ])
          ]);
      },
      append (data) {
          console.log(data.id)
          // this.getNodes(data);
          this.productActiveName = '新增'
          this.formVarietyInformation = {
            productTypeId: '',
            productTypeName: '',
            prodTypeFather: data.id,
            prodTypeLevel: '',
            // varietyChildId:'',
            orderNum:'',
            createBy:'',
            createDate:'',
            remark:'',
          },
          this.showProductTypeId = false;
          this.disabledInput = false;
          console.log(this)
          // const children = data.children || [];
          // children.push({
          //     title: 'appended node',
          //     expand: true
          // });
          // this.$set(data, 'children', children);
      },
      // remove (root, node, data) {
      //     const parentKey = root.find(el => el === node).parent;
      //     const parent = root.find(el => el.nodeKey === parentKey).node;
      //     const index = parent.children.indexOf(data);
      //     parent.children.splice(index, 1);
      // },


      getSelection(selection){
        // console.log(222)
          // console.log(selection)
          this.selectionRows = selection;
          // return selection;
      },
      // 搜索关键词
      showKeyList(){
          if(this.key == ''){
               this.$Message.error('查询关键词不能为空!');
          }else{
            let that = this;
            // console.log('通过关键词获取列表')
             api.Sign.getLists({
                  'page':that.pagerData.page.pageCurrent,
                  'limit':that.pagerData.page.pagesize,
                  'shopsign':that.key,
                  'productTypeId':that.selectgetNode.id,
              }, resp => {
                // console.log(resp)
                // 获取分页展示list
                that.pagerData.data = resp.page.list;
                // console.log(this.pagerData.data)
                // 获取分页总条数
                 that.pagerData.page.totalCount = resp.page.totalCount;
                 that.key = '';
              }, error => {
                
              })

          }
      },
        // 新增 初始化数据
      addAdmin(){
        this.activeName = '新增';
        this.formValidate={
          productTypeId:'',
          productTypeName:'',
          shopsign: '',
          techStandard: '',
          isValid: '',
          remark: '',
        },
          this.addModel = true
      },
      // 修改
      upDateAdmin(index){
        // console.log(this.selectionRows)
        this.activeName = '修改';
        if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
            this.$Message.error('请选择一条记录!');
            return;
        }
        if(this.selectionRows.length > 1){
           this.$Message.error('一次只能选择一个进行修改!');
           return;
        }
        this.formValidate={
          // currencyId:this.selectionRows[0].currencyId,
          productTypeId:this.selectionRows[0].productTypeId,
          productTypeName: this.selectionRows[0].productTypeName,
          shopsign:this.selectionRows[0].shopsign,
          techStandard: this.selectionRows[0].techStandard,
          isValid: this.selectionRows[0].isValid,
          remark: this.selectionRows[0].remark,
        },
        this.addModel = true
      },
      // 删除/批量删除
      delAdmins(){
        let that = this;
        if(that.selectionRows.length == undefined || that.selectionRows.length == 0){
            that.$Message.error('请至少选择一条记录!');
            return;
        }
        var currencyIds = [];
        for(var i=0 ;i < that.selectionRows.length; i++){
            // console.log(i);
            currencyIds.push(that.selectionRows[i].id);
        }
        api.Sign.delete(currencyIds
        , resp => {
          // console.log(resp)
          if(resp.code == 0){
            that.$Message.success('删除成功!');
            that.getLists(that.pagerData.page.pageCurrent,that.pagerData.page.pagesize);
          }
        }, error => {
        })
        // api.Role.delRole(roleIds
        // , resp => {
        //   console.log(resp)
        //   if(resp.code == 0){
        //     this.$Message.success('删除成功!');
        //     this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        //   }
        // }, error => {
        // })
      },

      getLists(pageCurrent,pagesize){
          // var token = sessionStorage.getItem("token");
          let that =this;
          let node = that.selectgetNode;
          api.Sign.getLists({
              'page':pageCurrent,
              'limit':pagesize,
              'productTypeId':node.id,
          }, resp => {
            console.log(resp)
             // 获取分页展示list
             that.pagerData.data = resp.page.list;
             console.log(that.pagerData.data)
             // 获取分页总条数
             that.pagerData.page.totalCount = resp.page.totalCount;
            // this.getallgateway();
          }, error => {

          })
      },
      // 分页 -- 页数改变
      onChange(curpage){  
          // alert("当前页面页码是：" + curpage);
          this.pagerData.page.pageCurrent = curpage;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      },
      // 分页 -- pageSize 改变
      sizeChange(size){
       // alert("当前页面size是：" + size);
        this.pagerData.page.pagesize = size;
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
      } ,
    },
    mounted(){ 
     // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // console.log(permissions)
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        // console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------
       this.getTree()
        //this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// product_type.vue?7821f3b2